<template>
  <div>
    <!-- graphe avec identifiants -->
    <div style="margin-top:10px;">
      <div style="min-height:20em, max-height:20em">
        <div style="padding:10px;" class="card">
          <div>
            <AdminEnAttenteTermine style="max-width:360px;" />
            <div style="margin-left:10px;">
              <b-checkbox
                :value="true"
                v-model="affichageIds"
                >{{ $t("admin.dots") }}</b-checkbox
              >
            </div>
          </div>
          <div style="">
            <Circles
              v-if="this.insight_checkrows_participants !== []"
              :affichageRoue="true"
              :diameter="windowWidth < 480 ? 220 : 360"
              :alwaysShow="false"
              :showDots="!affichageIds"
            />
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top:10px;">
      <div style="min-height:20em, max-height:20em">
        <div
          :style="replied ? 'height:3.2em' : ''"
          style="padding:10px;"
          class="card"
        >
          <p style="font-size:14px;color:#66b6e8">
            {{ $t("admin.listparticipants") }}
          </p>

          <!-- button déplier/replier -->
          <div
            @click="repliedFunc()"
            style="position:absolute; cursor:pointer;right:2px; top:2px;"
          >
            <b-icon
              v-if="!replied"
              pack="fas"
              icon="chevron-down"
              size="is-medium"
            ></b-icon>
            <b-icon
              v-else
              pack="fas"
              icon="chevron-up"
              size="is-medium"
            ></b-icon>
          </div>
          <div v-if="!replied">
            <div
              style="display:flex;padding:10px;justify-content:space-between;flex-wrap: wrap"
            >
              <div style="margin:15px auto !important;">
                <p>{{ $t("insight.numberProfiles") }}</p>
                <AdminPointsCumul :props="'only_checkboxs'" />
              </div>
              <div style="margin:35px auto !important;">
                <SearchBar />
              </div>
              <div style="margin:15px auto !important;">
                <p>{{ $t("admin.ptsCumulsNbColors.ptscumul") }}</p>
                <AdminPointsProfile :props="'only_checkboxs'" />
              </div>
            </div>
            <b-table
              default-sort="lastname"
              :data="filteredList"
              :striped="true"
              :hoverable="true"
              :checked-rows.sync="checkRows"
              checkable
              class="table-participants"
            >
              <template>
                <b-table-column
                  v-slot="props"
                  field="Id"
                  sortable
                  label="Id"
                  centered
                >
                  <p>{{ props.row.id_affichage_resultats }}</p>
                </b-table-column>

                <b-table-column
                  v-slot="props"
                  custom-key="admin.prenom"
                  field="firstname"
                  sortable
                  :label="$t('admin.prenom')"
                  centered
                >
                  <b-tooltip
                    type="is-danger"
                    :active="props.row.firstname.length > 15"
                    :label="props.row.firstname"
                    dashed
                    >{{ props.row.firstname | truncate(14) }}</b-tooltip
                  >
                </b-table-column>

                <b-table-column
                  v-slot="props"
                  custom-key="admin.nom"
                  field="lastname"
                  sortable
                  :label="$t('admin.nom')"
                  centered
                >
                  <b-tooltip
                    type="is-danger"
                    :active="props.row.lastname.length > 15"
                    :label="props.row.lastname"
                    dashed
                    >{{ props.row.lastname | truncate(14) }}</b-tooltip
                  >
                </b-table-column>
                <b-table-column
                  v-slot="props"
                  custom-key="admin.profil.dominant"
                  :label="$t('admin.profil.dominant')"
                  ><div style="max-height:10px">
                    <div
                      v-for="(color, key) in props.row.profil[0]"
                      :key="key"
                      :class="
                        backgroundColorPastilleDominante(
                          color,
                          key,
                          props.row.profil[0].length
                        )
                      "
                      @click="popUpsignificationCouleurPastilleDom(props, key)"
                    >
                      <b-tooltip
                        type="is-info"
                        :label="$t('admin.showSignificationColors')"
                      >
                        <div style="height:20px;width:20px;cursor:pointer" />
                      </b-tooltip>
                    </div>
                  </div>
                </b-table-column>
                <b-table-column
                  :height="20"
                  v-slot="props"
                  custom-key="admin.profil.inferieur"
                  :label="$t('admin.profil.inferieur')"
                  ><div style="max-height:10px">
                    <div
                      v-for="(color, key) in props.row.profil[1]"
                      :key="key"
                      :class="
                        backgroundColorPastilleInferieure(
                          color,
                          key,
                          props.row.profil[1].length
                        )
                      "
                      @click="popUpsignificationCouleurPastilleInf(props, key)"
                    >
                      <b-tooltip
                        type="is-info"
                        :label="$t('admin.showSignificationColors')"
                      >
                        <div style="height:20px;width:20px;cursor:pointer" />
                      </b-tooltip>
                    </div>
                  </div>
                </b-table-column>
                <!-- bleu -->
                <b-table-column
                  v-slot="props"
                  custom-key="c2"
                  numeric
                  sortable
                  field="color2"
                  :label="$t('c2')"
                  centered
                  style="background-color: rgba(0, 157, 255, 0.07);"
                >
                  <span @click="popUpsignificationCouleur(1)">{{
                    props.row.color2 !== 0 ? props.row.color2 : "--"
                  }}</span>
                </b-table-column>
                <!-- rouge -->
                <b-table-column
                  v-slot="props"
                  numeric
                  custom-key="c1"
                  sortable
                  field="color1"
                  :label="$t('c1')"
                  centered
                  style="background-color: rgba(255, 93, 0, 0.07);"
                >
                  <span @click="popUpsignificationCouleur(0)">{{
                    props.row.color1 !== 0 ? props.row.color1 : "--"
                  }}</span>
                </b-table-column>
                <!-- jaune -->
                <b-table-column
                  v-slot="props"
                  numeric
                  sortable
                  field="color3"
                  custom-key="c4"
                  :label="$t('c4')"
                  centered
                  style="background-color: rgba(255, 217, 0, 0.07);"
                >
                  <span @click="popUpsignificationCouleur(2)">{{
                    props.row.color4 !== 0 ? props.row.color4 : "--"
                  }}</span>
                </b-table-column>
                <!-- vert -->
                <b-table-column
                  v-slot="props"
                  numeric
                  sortable
                  field="color4"
                  custom-key="c3"
                  :label="$t('c3')"
                  centered
                  style="background-color: rgba(1, 163, 1, 0.07);"
                >
                  <span @click="popUpsignificationCouleur(3)">{{
                    props.row.color3 !== 0 ? props.row.color3 : "--"
                  }}</span>
                </b-table-column>

                <b-table-column
                  v-slot="props"
                  custom-key="admin.date"
                  field
                  sortable
                  numeric
                  centered
                  :label="$t('admin.date')"
                  >{{
                    props.row.created_at
                      .substring(0, 10)
                      .split("-")
                      .reverse()
                      .join("/")
                  }}</b-table-column
                >
              </template>
            </b-table>
            <AdminFinishedParticipants
              v-if="!this.array_participants_termine.length"
              :type="'noFinished'"
            />
            <AdminInfosSearchBarParticipants
              v-if="
                this.array_participants_termine.length &&
                  !this.filteredList.length
              "
            />
          </div>
        </div>
      </div>
    </div>
    <!-- chart energies -->
    <div style="margin-top:10px;" class="card columns">
      <div class="column is-full-mobile is-half-tablet is-half-desktop">
        <h3 style="font-size:14px;color:#66b6e8" class="has-text-centered">
          {{ $t("insight.energiesTotal") }}<span class="small-text"></span>
        </h3>
        <AdminEnergie
          :props="'energie'"
          :listFiltered="this.filteredList.length"
        />
      </div>
      <!-- chart energies dominantes -->
      <div class="column is-full-mobile is-half-tablet is-half-desktop">
        <h3 style="font-size:14px;color:#66b6e8" class="has-text-centered">
          {{ $t("insight.byDominants") }}<span class="small-text"></span>
        </h3>
        <AdminEnergie
          :props="'energie_dominante'"
          :listFiltered="this.filteredList.length"
        />
      </div>
    </div>
    <br />
    <!-- modal SignificationCouleur -->
    <b-modal :active.sync="isSignificationModalActive" :width="1000">
      <div>
        <significationCouleur :id="id" />
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EventBus from "../../../eventBus";
import AdminEnAttenteTermine from "@/components/insight/PageDashboard/AdminEnAttenteTermine";
import Circles from "../../base/Circles";
import AdminEnergie from "@/components/insight/PageDashboard/AdminEnergie";
import significationCouleur from "@/components/popup/SignificationCouleur";
import AdminFinishedParticipants from "@/components/insight/Utils/AdminFinishedParticipants";
import AdminInfosSearchBarParticipants from "@/components/insight/Utils/AdminInfosSearchBarParticipants";
import SearchBar from "@/components/insight/Utils/SearchBar";
import AdminPointsCumul from "@/components/insight/PageDashboard/AdminPointsCumul";
import AdminPointsProfile from "@/components/insight/PageDashboard/AdminPointsProfile";

export default {
  components: {
    AdminPointsCumul,
    AdminPointsProfile,
    Circles,
    AdminEnergie,
    significationCouleur,
    AdminEnAttenteTermine,
    AdminFinishedParticipants,
    SearchBar,
    AdminInfosSearchBarParticipants,
  },
  data() {
    return {
      affichageIds: true,
      url_moderateur: this.$route.params.url_moderateur,
      search: "",
      id: 1,
      isSignificationModalActive: false,
      checkRows: this.$store.getters.insight_checkrows_participants,
      id_affichage_checkrows: 0,
      index: -1,
      windowWidth: window.innerWidth,
      replied: false,
    };
  },
  computed: {
    ...mapGetters([
      "insight_nb_participants",
      "nb_participants_en_attente",
      "array_participants_termine",
      "insight_isLoadingResultats",
      "insight_checkrows_participants",
      "insight_search",
      "insight_id",
    ]),
    filteredList() {
      //this.calcCheckRows();
      this.$store.commit("INSIGHT_CHECKROWS_PARTICIPANTS", this.checkRows);
      this.calcul_pts_color_checkbox("PtsColorsCheckboxs");
      let array = this.array_participants_termine;
      return array.filter((x) => {
        return (
          x.firstname
            .toLowerCase()
            .includes(this.insight_search.toLowerCase()) ||
          x.lastname
            .toLowerCase()
            .includes(this.insight_search.toLowerCase()) ||
          x.email.toLowerCase().includes(this.insight_search.toLowerCase())
        );
      });
    },
  },
  created() {
    EventBus.$on("checkrows", this.dataCheckRowsCreated);
    EventBus.$on("updateparticipantcheckrow", this.calcCheckRows);
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("checkrows");
    EventBus.$off("updateparticipantcheckrow");
  },
  filters: {
    truncate(value, length) {
      return value.length > length ? value.substr(0, length) + "..." : value;
    },
  },
  methods: {
    repliedFunc() {
      this.replied = !this.replied;
    },
    calcCheckRows() {
      this.checkRows.push(
        this.array_participants_termine[
          this.array_participants_termine.length - 1
        ]
      );
    },
    dataCheckRowsCreated() {
      this.checkRows = this.$store.getters.insight_checkrows_participants;
    },
    calcul_pts_color_checkbox(PtsColorsCheckboxs) {
      EventBus.$emit("calcul_pts_color_checkbox", PtsColorsCheckboxs);
    },
    backgroundColorPastilleDominante(profil, key, length) {
      let cssClass = "";

      switch (length) {
        case 1:
          cssClass = `backgroundColor${profil}`;
          break;

        case 2:
          if (key === 0) {
            cssClass = `halfLeft color${profil + 1}`;
          } else {
            cssClass = `halfRight color${profil + 1}`;
          }
          break;

        case 3:
          if (key === 0) {
            cssClass = `thirdLeft color${profil + 1}`;
          } else if (key === 1) {
            cssClass = `thirdCenter color${profil + 1}`;
          } else {
            cssClass = `thirdRight color${profil + 1}`;
          }
          break;

        case 4:
          if (key === 0) {
            cssClass = `quarterTopLeft color${profil + 1}`;
          } else if (key === 1) {
            cssClass = `quarterTopRight color${profil + 1}`;
          } else if (key === 2) {
            cssClass = `quarterBottomLeft color${profil + 1}`;
          } else if (key === 3) {
            cssClass = `quarterBottomRight color${profil + 1}`;
          }
          break;

        default:
          break;
      }
      return cssClass;
    },
    backgroundColorPastilleInferieure(profil, key, length) {
      let cssClass = "";

      switch (length) {
        case 1:
          cssClass = `backgroundColor${profil}`;
          break;

        case 2:
          if (key === 0) {
            cssClass = `halfLeft color${profil + 1}`;
          } else {
            cssClass = `halfRight color${profil + 1}`;
          }
          break;

        case 3:
          if (key === 0) {
            cssClass = `thirdLeft color${profil + 1}`;
          } else if (key === 1) {
            cssClass = `thirdCenter color${profil + 1}`;
          } else {
            cssClass = `thirdRight color${profil + 1}`;
          }
          break;

        case 4:
          if (key === 0) {
            cssClass = `quarterTopLeft color${profil + 1}`;
          } else if (key === 1) {
            cssClass = `quarterTopRight color${profil + 1}`;
          } else if (key === 2) {
            cssClass = `quarterBottomLeft color${profil + 1}`;
          } else if (key === 3) {
            cssClass = `quarterBottomRight color${profil + 1}`;
          }
          break;

        default:
          break;
      }
      return cssClass;
    },
    classGiver(props, index) {
      if (index === 0) {
        return `halfCircleLeft${props.row.profilExtended[index]}`;
      } else {
        return `halfCircleRight${props.row.profilExtended[index]}`;
      }
    },
    popUpsignificationCouleurPastilleDom(props, key = 0) {
      this.id = props.row.profil[0][key];
      this.isSignificationModalActive = true;
    },
    popUpsignificationCouleurPastilleInf(props, key = 0) {
      this.id = props.row.profil[1][key];
      this.isSignificationModalActive = true;
    },
  },
};
</script>
<style scoped>
/* background des pastilles */
.backgroundColor0 {
  background-color: #ed5b07;
  position: relative;
  border-radius: 20px;
  height: 20px;
  width: 20px;
}
.backgroundColor1 {
  background-color: #448dfe;
  position: relative;
  border-radius: 20px;
  height: 20px;
  width: 20px;
}
.backgroundColor2 {
  background-color: #9edb58;
  position: relative;
  border-radius: 20px;
  height: 20px;
  width: 20px;
}
.backgroundColor3 {
  background-color: #f6da50;
  position: relative;
  border-radius: 20px;
  height: 20px;
  width: 20px;
}
.halfLeft {
  position: relative;
  border-radius: 10px 0px 0px 10px;
  width: 10px;
  height: 20px;
}
.halfRight {
  position: relative;
  border-radius: 0px 10px 10px 0px;
  width: 10px;
  height: 20px;
  bottom: 20px;
  left: 10px;
}
.thirdLeft {
  position: relative;
  border-radius: 10px 0px 0px 10px;
  width: 7px;
  height: 20px;
  z-index: 5;
}
.thirdCenter {
  position: relative;
  height: 21px;
  width: 20px;
  top: -20px;
  z-index: 1;
  border-radius: 10px;
}
.thirdRight {
  position: relative;
  border-radius: 0px 10px 10px 0px;
  width: 7px;
  height: 20px;
  top: -40px;
  z-index: 5;
  left: 13px;
}

.quarterTopLeft {
  position: relative;
  border-top-left-radius: 10px;
  width: 10px;
  height: 10px;
}
.quarterTopRight {
  position: relative;
  border-top-right-radius: 10px;
  width: 10px;
  height: 10px;
  top: -10px;
  left: 10px;
}
.quarterBottomLeft {
  position: relative;
  border-bottom-left-radius: 10px;
  width: 10px;
  height: 10px;
  top: -10px;
}
.quarterBottomRight {
  position: relative;
  border-bottom-right-radius: 10px;
  width: 10px;
  height: 10px;
  top: -20px;
  left: 10px;
}

.tabs:not(:last-child) {
  margin-bottom: 0rem;
}
.table-participants {
  max-height: 44vh;
  overflow-y: auto;
}
.space-1 {
  padding: 5px !important;
}
</style>
